import permission from "@/middlewares/permission";


function loadView( view ) {
    return () => import(`@/views/admin/Home/${ view }.vue`);
}


const Home = loadView('Home');

const homeRoutes = [
    {
        path: '',
        name: 'api.home',
        component: Home,
        meta: {
            middleware: permission
        }
    }
];

export default homeRoutes;
